import { render, staticRenderFns } from "./NautaAnnounce.vue?vue&type=template&id=a6374d24&scoped=true"
import script from "./NautaAnnounce.vue?vue&type=script&lang=js"
export * from "./NautaAnnounce.vue?vue&type=script&lang=js"
import style0 from "./NautaAnnounce.vue?vue&type=style&index=0&id=a6374d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6374d24",
  null
  
)

export default component.exports